import { SEEKER_USER_ROLE } from "datamodel/User/constants";
import { STEPS_SEEKER, STEPS_LISTER } from "./constants";

export const getSteps = (userRole) => {
  if (userRole === SEEKER_USER_ROLE) return STEPS_SEEKER;
  return STEPS_LISTER;
};
